import { useAuth } from 'century-core/core-auth/hooks/useAuth';
import { FeatureFlagDefaultValues, hasFeature, isFeatureOverrideEnabled } from 'century-core/core-auth/utils';

export const useHasNewAssignments = () => {
  const auth = useAuth();
  return hasFeature(auth, 'assignments', 'newAssignments', FeatureFlagDefaultValues.newAssignments);
};

export const useHasLegacyAssignments = () => {
  const auth = useAuth();
  return isFeatureOverrideEnabled(auth, 'assignments', false);
};

export const useHasAssignments = () => {
  const hasNewAssignments = useHasNewAssignments();
  const hasLegacyAssignments = useHasLegacyAssignments();
  return hasLegacyAssignments || hasNewAssignments;
};
